import { Button } from "#components/ui/button"
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from "#components/ui/drawer"
import { Sheet, SheetContent, SheetDescription, SheetTitle } from "#components/ui/sheet"
import { useDesktop } from "#hooks/use-desktop"
import { cn } from "#lib/utils"
import { MessageCircle } from "lucide-react"
import { useState } from "react"
import { ChatAgent } from "./chat-agent"

export function FloatingChat() {
  const [isOpen, setIsOpen] = useState(false)
  const isDesktop = useDesktop()

  const ChatContent = () => <ChatAgent onClose={() => setIsOpen(false)} />

  return (
    <>
      {/* Floating Button */}
      <Button
        onClick={() => setIsOpen(true)}
        className={cn(
          "fixed bottom-4 right-4 z-50 h-14 w-14 rounded-full shadow-lg",
          "hover:scale-110 transition-transform duration-200",
          "sm:bottom-6 sm:right-6"
        )}
        size="icon"
      >
        <MessageCircle className="h-6 w-6" />
        <span className="sr-only">Open chat assistant</span>
      </Button>

      {/* Desktop: Sheet from right */}
      {isDesktop && (
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
          <SheetContent
            side="right"
            className="w-full sm:w-[500px] p-0 flex flex-col h-full"
            showCloseButton={false}
          >
            <SheetTitle className="sr-only">Chat Assistant</SheetTitle>
            <SheetDescription className="sr-only">
              AI-powered assistant to help you manage your finances
            </SheetDescription>
            <ChatContent />
          </SheetContent>
        </Sheet>
      )}

      {/* Mobile: Drawer from bottom */}
      {!isDesktop && (
        <Drawer open={isOpen} onOpenChange={setIsOpen}>
          <DrawerContent className="max-h-[90vh] p-0 flex flex-col">
            <DrawerTitle className="sr-only">Chat Assistant</DrawerTitle>
            <DrawerDescription className="sr-only">
              AI-powered assistant to help you manage your finances
            </DrawerDescription>
            <ChatContent />
          </DrawerContent>
        </Drawer>
      )}
    </>
  )
}
